import React from "react";
import { Col, Row } from "react-bootstrap";
import * as CgIcons from "react-icons/si";
import * as DiIcons from "react-icons/di"; 
import dataBaseData from "../../dataBase.json";


function DataBases() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {dataBaseData.DataBase.map((database) => {
        const IconComponent = DiIcons[database.icon] || CgIcons[database.icon]; 
        return (
          <Col key={database.id} xs={4} md={2} className="tech-icons">
            {IconComponent && <IconComponent />}
          </Col>
        );
      })}
    </Row>
  );
}

export default DataBases;
